import { Dialog } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useService } from '~/services/service.base';
import { DialogService } from '~/services/service.dialog';
import { IAlertDialog } from '~/views/types';

interface ErrorObj {
    description?: string;
    code?: string;
}

interface AlertDialogProps extends IAlertDialog {
    error?: ErrorObj;
}

export const AlertDialog: FC<AlertDialogProps> = observer(props => {
    const dialogService = useService(DialogService);
    const { alertDialogSrv } = dialogService;

    const headerText =
        props.headerText || (props.error?.description ? 'Something went wrong' : '') || alertDialogSrv.headerText;

    const mainText = props.mainText || props.error?.description || alertDialogSrv.mainText;

    const showContactInfo =
        typeof props.showContactInfo === 'boolean' ? props.showContactInfo : alertDialogSrv.showContactInfo;

    return (
        <Dialog open={alertDialogSrv.open} className="hr-modal-dialog">
            <div className="modal-dialog modal-dialog-centered alert-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="modalContent">
                            <h3>{headerText}</h3>
                            <p>{mainText}</p>
                            <div className="alert-dialog-actions">
                                <button type="button" className="btn" onClick={alertDialogSrv.handleClose}>
                                    OK
                                </button>
                            </div>
                            {showContactInfo && (
                                <div className="alert-contact-info">
                                    <a href="mailto:customercare@hardrockgames.com">contact support</a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
});
